import ga from './ga';

export const trackEvent = (name, args) => {
  if (window.heap) {
    window.heap.track(name, args);
  }
  ga.gtag('event', name, args);
}